import React, { useState } from "react";

import { graphql, createFragmentContainer } from "react-relay";
import PodcastPlayer from "../PodcastPlayer";
import PodcastList from "./PodcastList";
import Button from "../../../Button";
import PodcastUploadStatus from "../PodcastUploadStatus";

function Podcasts(props) {
  const [activePodcast, setActivePodcast] = useState(props.podcasts[0]);

  function updateActivePodcast(e, podcast) {
    setActivePodcast(podcast);

    window.scrollTo(0, 0);
  }

  return (
    <>
      {props.isAdmin ? (
        <Button href="/podcasts/upload">Upload Podcast</Button>
      ) : null}
      <PodcastPlayer podcast={activePodcast} />

      {props.isAdmin ? (
        <React.Suspense fallback={""}>
          <PodcastUploadStatus />
        </React.Suspense>
      ) : null}

      <PodcastList
        podcasts={props.podcasts}
        setActivePodcast={updateActivePodcast}
        isAdmin={props.isAdmin}
      />
    </>
  );
}

export default createFragmentContainer(Podcasts, {
  podcasts: graphql`
    fragment Podcasts_podcasts on PodcastType @relay(plural: true) {
      ...PodcastPlayer_podcast
    }
  `,
});
